import './styles.css';
import {
  initI18n,
  AVAILABLE_LOCALES,
  type LandingLocale,
} from './i18n/I18n.js';
import { renderPage } from './sections/render.js';
import { hydrateHeaderAuth } from './sections/headerAuth.js';
import { mountLandingInviteDock } from './socialDock.js';

function localeFromPath(): LandingLocale {
  const path = window.location.pathname;
  const seg = path.split('/').filter((s) => s.length > 0)[0];
  if (seg !== undefined && AVAILABLE_LOCALES.includes(seg as LandingLocale)) {
    return seg as LandingLocale;
  }
  return 'en';
}

function wireLangDropdown(): void {
  const details = document.querySelector<HTMLDetailsElement>('.lang-select');
  if (details === null) return;
  document.addEventListener('click', (e) => {
    if (!details.contains(e.target as Node)) {
      details.open = false;
    }
  });
}

async function bootstrap(): Promise<void> {
  const locale = localeFromPath();
  await initI18n(locale);
  const root = document.getElementById('app');
  if (root === null) return;
  root.innerHTML = renderPage(locale);
  wireLangDropdown();
  hydrateHeaderAuth();
  void mountLandingInviteDock(locale);
}

void bootstrap();
